// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2018 Red Hat, Inc. and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

.theia-debug-container,
.theia-session-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.theia-debug-container .theia-select {
  margin-left: var(--theia-ui-padding);
}

.theia-source-breakpoint,
.theia-debug-session,
.theia-debug-thread,
.theia-debug-stack-frame {
  display: flex;
  align-items: center;
}

.theia-source-breakpoint > span,
.theia-debug-session > span,
.theia-debug-thread > span,
.theia-debug-stack-frame > span,
.theia-debug-stack-frame .file > span {
  margin-left: calc(var(--theia-ui-padding) / 2);
}

.theia-debug-session .label,
.theia-debug-thread .label,
.theia-debug-stack-frame .expression {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.theia-source-breakpoint .path {
  font-size: var(--theia-ui-font-size0);
}

.theia-source-breakpoint .line-info {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
}

.theia-source-breakpoint .line,
.theia-debug-stack-frame .line {
  background: var(--theia-descriptionForeground);
  color: var(--theia-editor-background);
  padding: calc(var(--theia-ui-padding) / 3);
  font-size: var(--theia-ui-font-size0);
  line-height: calc(var(--theia-private-horizontal-tab-height) / 2);
  border-radius: 2px;
}

.theia-debug-session .status,
.theia-debug-thread .status {
  text-transform: uppercase;
  white-space: nowrap;
}

.theia-debug-stack-frame .expression {
  white-space: pre;
}

.theia-debug-stack-frame.label {
  text-align: center;
  font-style: italic;
}

.theia-debug-stack-frame.subtle {
  font-style: italic;
}

.theia-debug-stack-frame .file > span {
  white-space: nowrap;
}

.theia-load-more-frames {
  text-align: center;
  font-style: italic;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
}

/** Miscellaneous */

.debug-toolbar {
  display: flex;
  align-items: center;
  padding-top: calc(var(--theia-ui-padding) * 2);
  padding-right: calc(var(--theia-ui-padding) * 3);
  padding-bottom: var(--theia-ui-padding);
  padding-left: calc(var(--theia-ui-padding) * 2);
}

.theia-session-container > .debug-toolbar {
  padding-top: var(--theia-ui-padding);
  padding-bottom: var(--theia-ui-padding);
  border-bottom: 1px solid var(--theia-sideBarSectionHeader-border);
}

.debug-toolbar .theia-select-component {
  width: 100%;
  min-width: 40px;
  margin: 0px 4px;
}

.debug-toolbar .debug-action {
  opacity: 0.9;
  cursor: pointer;
  pointer-events: all;
  padding-left: var(--theia-ui-padding);
  padding-right: var(--theia-ui-padding);
  min-width: var(--theia-icon-size);
  min-height: var(--theia-icon-size);
}

.debug-toolbar .debug-action.theia-mod-disabled {
  opacity: 0.5 !important;
  user-select: none;
  pointer-events: none;
}

.debug-toolbar .debug-action:not(.theia-mod-disabled):hover {
  opacity: 1;
}

.debug-toolbar .debug-action > div {
  font-family: var(--theia-ui-font-family);
  font-size: var(--theia-ui-font-size0);
  display: flex;
  align-items: center;
  align-self: center;
  justify-content: center;
  text-align: center;
  min-height: inherit;
}

/** Console */

#debug-console .theia-console-info {
  color: var(--theia-debugConsole-infoForeground) !important;
}
#debug-console .theia-console-warning {
  color: var(--theia-debugConsole-warningForeground) !important;
}
#debug-console .theia-console-error {
  color: var(--theia-debugConsole-errorForeground) !important;
}

.theia-debug-console-unavailable {
  font-style: italic;
}

.theia-debug-console-expression {
  display: flex;
  flex-direction: column;
  white-space: pre-wrap;
}

.theia-debug-console-variable {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--theia-variable-value-color);
}

.theia-debug-hover-title.number,
.theia-debug-console-variable.number {
  color: var(--theia-variable-number-variable-color);
}

.theia-debug-hover-title.boolean,
.theia-debug-console-variable.boolean {
  color: var(--theia-variable-boolean-variable-color);
}

.theia-debug-hover-title.string,
.theia-debug-console-variable.string {
  color: var(--theia-variable-string-variable-color);
}

.theia-debug-console-variable .name {
  color: var(--theia-variable-name-color);
}

.theia-TreeNode:not(:hover) .theia-debug-console-variable .action-label {
  visibility: hidden;
}

.theia-debug-console-variable .action-label {
  /* Vertically center the button in the tree node */
  margin: auto;
}

.theia-debug-console-variable .watch-error {
  font-style: italic;
  color: var(--theia-debugConsole-errorForeground);
}

.theia-debug-watch-expression {
  display: flex;
}

/** Editor **/

.theia-debug-breakpoint-icon {
  font-size: 19px !important;
  width: 19px;
  height: 19px;
  min-width: 19px;
  margin-left: 0px !important;
}

.codicon-debug-hint {
  cursor: pointer;
}

.codicon-debug-breakpoint,
.codicon-debug-breakpoint-conditional,
.codicon-debug-breakpoint-log,
.codicon-debug-breakpoint-function,
.codicon-debug-breakpoint-data,
.codicon-debug-breakpoint-unsupported,
.codicon-debug-hint:not([class*="codicon-debug-breakpoint"]):not(
    [class*="codicon-debug-stackframe"]
  ),
.codicon-debug-breakpoint.codicon-debug-stackframe-focused::after,
.codicon-debug-breakpoint.codicon-debug-stackframe::after {
  color: var(--theia-debugIcon-breakpointForeground) !important;
}

.codicon[class*="-disabled"] {
  color: var(--theia-debugIcon-breakpointDisabledForeground) !important;
}

.codicon[class*="-unverified"] {
  color: var(--theia-debugIcon-breakpointUnverifiedForeground) !important;
}

.codicon-debug-stackframe,
.monaco-editor .theia-debug-top-stack-frame-column::before {
  color: var(
    --theia-debugIcon-breakpointCurrentStackframeForeground
  ) !important;
}

.codicon-debug-stackframe-focused {
  color: var(--theia-debugIcon-breakpointStackframeForeground) !important;
}

.codicon-debug-breakpoint.codicon-debug-stackframe-focused::after,
.codicon-debug-breakpoint.codicon-debug-stackframe::after {
  content: "\\eb8a";
  position: absolute;
}

.monaco-editor .theia-debug-breakpoint-column::before {
  height: 0.9em;
  display: inline-flex;
  vertical-align: middle;
}

.monaco-editor .theia-debug-top-stack-frame-column::before {
  content: " ";
  width: 0.9em;
  display: inline-flex;
  vertical-align: middle;
  margin-top: -1px; /* TODO @misolori: figure out a way to not use negative margin for alignment */
}

.monaco-editor .theia-debug-top-stack-frame-column {
  display: inline-flex;
  vertical-align: middle;
}

.monaco-editor .theia-debug-top-stack-frame-column::before {
  content: "\\eb8b";
  font: normal normal normal 16px/1 codicon;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-left: 0;
  margin-right: 4px;
}

.codicon-debug-hint:not([class*="codicon-debug-breakpoint"]):not(
    [class*="codicon-debug-stackframe"]
  ) {
  opacity: 0.4 !important;
}

.monaco-editor .view-overlays .theia-debug-top-stack-frame-line {
  background: var(--theia-editor-stackFrameHighlightBackground);
}

.monaco-editor .view-overlays .theia-debug-focused-stack-frame-line {
  background: var(--theia-editor-focusedStackFrameHighlightBackground);
}

/** Toolbars */

.codicon-debug-start {
  color: var(--theia-debugIcon-startForeground) !important;
}
.codicon-debug-pause {
  color: var(--theia-debugIcon-pauseForeground) !important;
}

.codicon-debug-stop {
  color: var(--theia-debugIcon-stopForeground) !important;
}
.codicon-debug-disconnect {
  color: var(--theia-debugIcon-disconnectForeground) !important;
}
.codicon-debug-restart,
.codicon-debug-restart-frame {
  color: var(--theia-debugIcon-restartForeground) !important;
}
.codicon-debug-step-over {
  color: var(--theia-debugIcon-stepOverForeground) !important;
}
.codicon-debug-step-into {
  color: var(--theia-debugIcon-stepIntoForeground) !important;
}
.codicon-debug-step-out {
  color: var(--theia-debugIcon-stepOutForeground) !important;
}
.codicon-debug-continue,
.codicon-debug-reverse-continue {
  color: var(--theia-debugIcon-continueForeground) !important;
}

.codicon-debug-step-back {
  color: var(--theia-debugIcon-stepBackForeground) !important;
}

/** Hover */
.theia-debug-hover {
  display: flex !important;
  flex-direction: column;
  border: 1px solid var(--theia-editorHoverWidget-border);
  background: var(--theia-editorHoverWidget-background);
  color: var(--theia-editorHoverWidget-foreground);
}

.theia-debug-hover.complex-value {
  min-width: 324px;
  min-height: 324px;
  width: 324px;
  height: 324px;
}

.theia-debug-hover .theia-source-tree {
  height: 100%;
  width: 100%;
}

.theia-debug-hover-title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: var(--theia-ui-padding);
  border-bottom: 1px solid var(--theia-editorHoverWidget-border);
}

.theia-debug-hover-content {
  display: flex;
  flex: 1;
  overflow-y: auto;
}

/** Breakpoint Widget */
.theia-debug-breakpoint-widget {
  display: flex;
}

.theia-debug-breakpoint-select {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 0 10px;
  flex-shrink: 0;
}

.theia-debug-breakpoint-input {
  flex: 1;
  margin-top: var(--theia-ui-padding);
  margin-bottom: var(--theia-ui-padding);
}

/* Status Bar */
.theia-mod-debugging #theia-statusBar {
  background: var(--theia-statusBar-debuggingBackground);
  border-top: var(--theia-border-width) solid
    var(--theia-statusBar-debuggingBorder);
}

.theia-mod-debugging #theia-statusBar .area .element {
  color: var(--theia-statusBar-debuggingForeground);
}

/** Exception Widget */
.monaco-editor
  .zone-widget
  .zone-widget-container.theia-debug-exception-widget {
  color: var(--theia-editor-foreground);
  font-size: var(--theia-code-font-size);
  line-height: var(--theia-code-line-height);
  font-family: var(--theia-code-font-family);
  border-top-color: var(--theia-debugExceptionWidget-border);
  border-bottom-color: var(--theia-debugExceptionWidget-border);
  background-color: var(--theia-debugExceptionWidget-background);
  padding: var(--theia-ui-padding) calc(var(--theia-ui-padding) * 1.5);
  white-space: pre-wrap;
  user-select: text;
  overflow: hidden;
}

.theia-debug-exception-widget .title {
  font-family: var(--theia-ui-font-family);
  font-weight: bold;
}

.theia-debug-exception-widget .stack-trace {
  margin-top: 0.5em;
}

.theia-debug-exception-widget #exception-close {
  cursor: pointer;
  margin-left: 5px;
  vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/debug/src/browser/style/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;EAKE,8CAA8C;AAChD;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,8CAA8C;EAC9C,qCAAqC;EACrC,0CAA0C;EAC1C,qCAAqC;EACrC,iEAAiE;EACjE,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA,mBAAmB;;AAEnB;EACE,aAAa;EACb,mBAAmB;EACnB,8CAA8C;EAC9C,gDAAgD;EAChD,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,iEAAiE;AACnE;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,qCAAqC;EACrC,sCAAsC;EACtC,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,aAAa;;AAEb;EACE,0DAA0D;AAC5D;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;;EAEE,kDAAkD;AACpD;;AAEA;;EAEE,mDAAmD;AACrD;;AAEA;;EAEE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kDAAkD;EAClD,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,aAAa;AACf;;AAEA,aAAa;;AAEb;EACE,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;;;;;;EAWE,6DAA6D;AAC/D;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,uEAAuE;AACzE;;AAEA;;EAEE;;cAEY;AACd;;AAEA;EACE,uEAAuE;AACzE;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB,EAAE,8EAA8E;AAClG;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;EAClC,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,oEAAoE;AACtE;;AAEA,cAAc;;AAEd;EACE,wDAAwD;AAC1D;AACA;EACE,wDAAwD;AAC1D;;AAEA;EACE,uDAAuD;AACzD;AACA;EACE,6DAA6D;AAC/D;AACA;;EAEE,0DAA0D;AAC5D;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,0DAA0D;AAC5D;AACA;;EAEE,2DAA2D;AAC7D;;AAEA;EACE,2DAA2D;AAC7D;;AAEA,WAAW;AACX;EACE,wBAAwB;EACxB,sBAAsB;EACtB,uDAAuD;EACvD,qDAAqD;EACrD,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,8DAA8D;AAChE;;AAEA;EACE,aAAa;EACb,OAAO;EACP,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA,eAAe;AACf;EACE,sDAAsD;EACtD;0CACwC;AAC1C;;AAEA;EACE,iDAAiD;AACnD;;AAEA,sBAAsB;AACtB;;;EAGE,qCAAqC;EACrC,sCAAsC;EACtC,0CAA0C;EAC1C,0CAA0C;EAC1C,0DAA0D;EAC1D,6DAA6D;EAC7D,8DAA8D;EAC9D,oEAAoE;EACpE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB","sourcesContent":["/********************************************************************************\n * Copyright (C) 2018 Red Hat, Inc. and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n.theia-debug-container,\n.theia-session-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.theia-debug-container .theia-select {\n  margin-left: var(--theia-ui-padding);\n}\n\n.theia-source-breakpoint,\n.theia-debug-session,\n.theia-debug-thread,\n.theia-debug-stack-frame {\n  display: flex;\n  align-items: center;\n}\n\n.theia-source-breakpoint > span,\n.theia-debug-session > span,\n.theia-debug-thread > span,\n.theia-debug-stack-frame > span,\n.theia-debug-stack-frame .file > span {\n  margin-left: calc(var(--theia-ui-padding) / 2);\n}\n\n.theia-debug-session .label,\n.theia-debug-thread .label,\n.theia-debug-stack-frame .expression {\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.theia-source-breakpoint .path {\n  font-size: var(--theia-ui-font-size0);\n}\n\n.theia-source-breakpoint .line-info {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n  white-space: nowrap;\n}\n\n.theia-source-breakpoint .line,\n.theia-debug-stack-frame .line {\n  background: var(--theia-descriptionForeground);\n  color: var(--theia-editor-background);\n  padding: calc(var(--theia-ui-padding) / 3);\n  font-size: var(--theia-ui-font-size0);\n  line-height: calc(var(--theia-private-horizontal-tab-height) / 2);\n  border-radius: 2px;\n}\n\n.theia-debug-session .status,\n.theia-debug-thread .status {\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.theia-debug-stack-frame .expression {\n  white-space: pre;\n}\n\n.theia-debug-stack-frame.label {\n  text-align: center;\n  font-style: italic;\n}\n\n.theia-debug-stack-frame.subtle {\n  font-style: italic;\n}\n\n.theia-debug-stack-frame .file > span {\n  white-space: nowrap;\n}\n\n.theia-load-more-frames {\n  text-align: center;\n  font-style: italic;\n  white-space: nowrap;\n  display: flex;\n  flex-direction: column;\n}\n\n/** Miscellaneous */\n\n.debug-toolbar {\n  display: flex;\n  align-items: center;\n  padding-top: calc(var(--theia-ui-padding) * 2);\n  padding-right: calc(var(--theia-ui-padding) * 3);\n  padding-bottom: var(--theia-ui-padding);\n  padding-left: calc(var(--theia-ui-padding) * 2);\n}\n\n.theia-session-container > .debug-toolbar {\n  padding-top: var(--theia-ui-padding);\n  padding-bottom: var(--theia-ui-padding);\n  border-bottom: 1px solid var(--theia-sideBarSectionHeader-border);\n}\n\n.debug-toolbar .theia-select-component {\n  width: 100%;\n  min-width: 40px;\n  margin: 0px 4px;\n}\n\n.debug-toolbar .debug-action {\n  opacity: 0.9;\n  cursor: pointer;\n  pointer-events: all;\n  padding-left: var(--theia-ui-padding);\n  padding-right: var(--theia-ui-padding);\n  min-width: var(--theia-icon-size);\n  min-height: var(--theia-icon-size);\n}\n\n.debug-toolbar .debug-action.theia-mod-disabled {\n  opacity: 0.5 !important;\n  user-select: none;\n  pointer-events: none;\n}\n\n.debug-toolbar .debug-action:not(.theia-mod-disabled):hover {\n  opacity: 1;\n}\n\n.debug-toolbar .debug-action > div {\n  font-family: var(--theia-ui-font-family);\n  font-size: var(--theia-ui-font-size0);\n  display: flex;\n  align-items: center;\n  align-self: center;\n  justify-content: center;\n  text-align: center;\n  min-height: inherit;\n}\n\n/** Console */\n\n#debug-console .theia-console-info {\n  color: var(--theia-debugConsole-infoForeground) !important;\n}\n#debug-console .theia-console-warning {\n  color: var(--theia-debugConsole-warningForeground) !important;\n}\n#debug-console .theia-console-error {\n  color: var(--theia-debugConsole-errorForeground) !important;\n}\n\n.theia-debug-console-unavailable {\n  font-style: italic;\n}\n\n.theia-debug-console-expression {\n  display: flex;\n  flex-direction: column;\n  white-space: pre-wrap;\n}\n\n.theia-debug-console-variable {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: var(--theia-variable-value-color);\n}\n\n.theia-debug-hover-title.number,\n.theia-debug-console-variable.number {\n  color: var(--theia-variable-number-variable-color);\n}\n\n.theia-debug-hover-title.boolean,\n.theia-debug-console-variable.boolean {\n  color: var(--theia-variable-boolean-variable-color);\n}\n\n.theia-debug-hover-title.string,\n.theia-debug-console-variable.string {\n  color: var(--theia-variable-string-variable-color);\n}\n\n.theia-debug-console-variable .name {\n  color: var(--theia-variable-name-color);\n}\n\n.theia-TreeNode:not(:hover) .theia-debug-console-variable .action-label {\n  visibility: hidden;\n}\n\n.theia-debug-console-variable .action-label {\n  /* Vertically center the button in the tree node */\n  margin: auto;\n}\n\n.theia-debug-console-variable .watch-error {\n  font-style: italic;\n  color: var(--theia-debugConsole-errorForeground);\n}\n\n.theia-debug-watch-expression {\n  display: flex;\n}\n\n/** Editor **/\n\n.theia-debug-breakpoint-icon {\n  font-size: 19px !important;\n  width: 19px;\n  height: 19px;\n  min-width: 19px;\n  margin-left: 0px !important;\n}\n\n.codicon-debug-hint {\n  cursor: pointer;\n}\n\n.codicon-debug-breakpoint,\n.codicon-debug-breakpoint-conditional,\n.codicon-debug-breakpoint-log,\n.codicon-debug-breakpoint-function,\n.codicon-debug-breakpoint-data,\n.codicon-debug-breakpoint-unsupported,\n.codicon-debug-hint:not([class*=\"codicon-debug-breakpoint\"]):not(\n    [class*=\"codicon-debug-stackframe\"]\n  ),\n.codicon-debug-breakpoint.codicon-debug-stackframe-focused::after,\n.codicon-debug-breakpoint.codicon-debug-stackframe::after {\n  color: var(--theia-debugIcon-breakpointForeground) !important;\n}\n\n.codicon[class*=\"-disabled\"] {\n  color: var(--theia-debugIcon-breakpointDisabledForeground) !important;\n}\n\n.codicon[class*=\"-unverified\"] {\n  color: var(--theia-debugIcon-breakpointUnverifiedForeground) !important;\n}\n\n.codicon-debug-stackframe,\n.monaco-editor .theia-debug-top-stack-frame-column::before {\n  color: var(\n    --theia-debugIcon-breakpointCurrentStackframeForeground\n  ) !important;\n}\n\n.codicon-debug-stackframe-focused {\n  color: var(--theia-debugIcon-breakpointStackframeForeground) !important;\n}\n\n.codicon-debug-breakpoint.codicon-debug-stackframe-focused::after,\n.codicon-debug-breakpoint.codicon-debug-stackframe::after {\n  content: \"\\eb8a\";\n  position: absolute;\n}\n\n.monaco-editor .theia-debug-breakpoint-column::before {\n  height: 0.9em;\n  display: inline-flex;\n  vertical-align: middle;\n}\n\n.monaco-editor .theia-debug-top-stack-frame-column::before {\n  content: \" \";\n  width: 0.9em;\n  display: inline-flex;\n  vertical-align: middle;\n  margin-top: -1px; /* TODO @misolori: figure out a way to not use negative margin for alignment */\n}\n\n.monaco-editor .theia-debug-top-stack-frame-column {\n  display: inline-flex;\n  vertical-align: middle;\n}\n\n.monaco-editor .theia-debug-top-stack-frame-column::before {\n  content: \"\\eb8b\";\n  font: normal normal normal 16px/1 codicon;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  margin-left: 0;\n  margin-right: 4px;\n}\n\n.codicon-debug-hint:not([class*=\"codicon-debug-breakpoint\"]):not(\n    [class*=\"codicon-debug-stackframe\"]\n  ) {\n  opacity: 0.4 !important;\n}\n\n.monaco-editor .view-overlays .theia-debug-top-stack-frame-line {\n  background: var(--theia-editor-stackFrameHighlightBackground);\n}\n\n.monaco-editor .view-overlays .theia-debug-focused-stack-frame-line {\n  background: var(--theia-editor-focusedStackFrameHighlightBackground);\n}\n\n/** Toolbars */\n\n.codicon-debug-start {\n  color: var(--theia-debugIcon-startForeground) !important;\n}\n.codicon-debug-pause {\n  color: var(--theia-debugIcon-pauseForeground) !important;\n}\n\n.codicon-debug-stop {\n  color: var(--theia-debugIcon-stopForeground) !important;\n}\n.codicon-debug-disconnect {\n  color: var(--theia-debugIcon-disconnectForeground) !important;\n}\n.codicon-debug-restart,\n.codicon-debug-restart-frame {\n  color: var(--theia-debugIcon-restartForeground) !important;\n}\n.codicon-debug-step-over {\n  color: var(--theia-debugIcon-stepOverForeground) !important;\n}\n.codicon-debug-step-into {\n  color: var(--theia-debugIcon-stepIntoForeground) !important;\n}\n.codicon-debug-step-out {\n  color: var(--theia-debugIcon-stepOutForeground) !important;\n}\n.codicon-debug-continue,\n.codicon-debug-reverse-continue {\n  color: var(--theia-debugIcon-continueForeground) !important;\n}\n\n.codicon-debug-step-back {\n  color: var(--theia-debugIcon-stepBackForeground) !important;\n}\n\n/** Hover */\n.theia-debug-hover {\n  display: flex !important;\n  flex-direction: column;\n  border: 1px solid var(--theia-editorHoverWidget-border);\n  background: var(--theia-editorHoverWidget-background);\n  color: var(--theia-editorHoverWidget-foreground);\n}\n\n.theia-debug-hover.complex-value {\n  min-width: 324px;\n  min-height: 324px;\n  width: 324px;\n  height: 324px;\n}\n\n.theia-debug-hover .theia-source-tree {\n  height: 100%;\n  width: 100%;\n}\n\n.theia-debug-hover-title {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  padding: var(--theia-ui-padding);\n  border-bottom: 1px solid var(--theia-editorHoverWidget-border);\n}\n\n.theia-debug-hover-content {\n  display: flex;\n  flex: 1;\n  overflow-y: auto;\n}\n\n/** Breakpoint Widget */\n.theia-debug-breakpoint-widget {\n  display: flex;\n}\n\n.theia-debug-breakpoint-select {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  padding: 0 10px;\n  flex-shrink: 0;\n}\n\n.theia-debug-breakpoint-input {\n  flex: 1;\n  margin-top: var(--theia-ui-padding);\n  margin-bottom: var(--theia-ui-padding);\n}\n\n/* Status Bar */\n.theia-mod-debugging #theia-statusBar {\n  background: var(--theia-statusBar-debuggingBackground);\n  border-top: var(--theia-border-width) solid\n    var(--theia-statusBar-debuggingBorder);\n}\n\n.theia-mod-debugging #theia-statusBar .area .element {\n  color: var(--theia-statusBar-debuggingForeground);\n}\n\n/** Exception Widget */\n.monaco-editor\n  .zone-widget\n  .zone-widget-container.theia-debug-exception-widget {\n  color: var(--theia-editor-foreground);\n  font-size: var(--theia-code-font-size);\n  line-height: var(--theia-code-line-height);\n  font-family: var(--theia-code-font-family);\n  border-top-color: var(--theia-debugExceptionWidget-border);\n  border-bottom-color: var(--theia-debugExceptionWidget-border);\n  background-color: var(--theia-debugExceptionWidget-background);\n  padding: var(--theia-ui-padding) calc(var(--theia-ui-padding) * 1.5);\n  white-space: pre-wrap;\n  user-select: text;\n  overflow: hidden;\n}\n\n.theia-debug-exception-widget .title {\n  font-family: var(--theia-ui-font-family);\n  font-weight: bold;\n}\n\n.theia-debug-exception-widget .stack-trace {\n  margin-top: 0.5em;\n}\n\n.theia-debug-exception-widget #exception-close {\n  cursor: pointer;\n  margin-left: 5px;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
